import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=a1ae8030&lang=pug&"
import script from "./ContentHeader.vue?vue&type=script&lang=js&"
export * from "./ContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports